<template>
  <DashboardPage>
    <PageBreadcrumb
      :crumbs="[{
        label: 'Profilo Utente'
      }]"
    />
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
      <ActionButton @click="changePassword">
        Cambia Password
      </ActionButton>
    </div>
  </DashboardPage>
</template>

<script setup>
import ActionButton from '@/components/ActionButton.vue';
import DashboardCard from '@/components/DashboardCard.vue';
import DashboardPage from '@/components/DashboardPage.vue'
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import { useLoadingStore } from '@/stores/loading';
import { useNotificationsStore } from '@/stores/notifications';

const axios = useAxios()
const notificationStore = useNotificationsStore()
const loadingStore = useLoadingStore()

const changePassword = function() {
  axios.get('/profile/passwordChangeUrl?returnUrl=' + encodeURIComponent(window.location.href)).then(resp => {
    window.location.href = resp.data.url;
  });
}
</script>